import { EnderecoDne } from './../shared/model/endereco-dne.model';
import { Observable } from 'rxjs';
import { McticHttpClient } from '@mctic/ng-core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DneService {

  private ENDPOINT = "/sepin-backend/rest/proxy/dne/logradouro";

  constructor(private mcticHttp: McticHttpClient) { }

  consultar(cep: String): Observable<EnderecoDne> {
    return this.mcticHttp.http.get<EnderecoDne>(`${this.ENDPOINT}/${cep}`);
  }
}
